module.exports = __webpack_public_path__ + "media/images/front/icons/arrow-up-3edea299419864cf2d8ca9fb3f014b99.svg";